import * as React from 'react';
import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../common/state';
import { TMultiSelectChangedAction } from '../../../../../common/state/actions';
import { IJsonQueryTermsParams } from '../../../../../json_query';
import { Row } from '../../markup';
import { ButtonCheckboxList, IOption } from '../button_checkbox_list';

interface IChangeHandler<T> {
  (paramType: T, paramAddeed: boolean): TMultiSelectChangedAction;
}

interface IMultiSelectProps<T> {
  titleComment?: string;
  selected: T[];
  onParamChange(paramType: T, isAdded: boolean): void;
}

// without 'extends' compiler would treat generic as html tag
export const getMultiSelectParam = <T extends Object>(
  title: string,
  values: IOption<T>[],

  jsonQueryParamName: keyof IJsonQueryTermsParams,
  changeHandler: IChangeHandler<T>,
) => {
  const MultiSelect: React.StatelessComponent<IMultiSelectProps<T>> = props => (
    <Row
      title={
        <span>
          {title}
          <br />
          {props.titleComment || ''}
        </span>
      }
    >
      <ButtonCheckboxList
        list={values}
        selected={props.selected}
        select={(value: T) => props.onParamChange(value, true)}
        deselect={(value: T) => props.onParamChange(value, false)}
      />
    </Row>
  );

  return connect<
    // tslint:disable-next-line:no-any
    { selected: any },
    { onParamChange(paramType: T, value: boolean): void },
    { titleComment?: string }
  >(
    (state: IAppState) => ({
      selected:
        (state.filters.jsonQuery[jsonQueryParamName] &&
          // tslint:disable-next-line:no-any
          (state.filters.jsonQuery[jsonQueryParamName] as any).value) ||
        [],
    }),
    (dispatch: Dispatch) => ({
      onParamChange: (paramType: T, value: boolean): void => {
        dispatch(changeHandler(paramType, value));
      },
    }),
  )(MultiSelect);
};
